query allBaseballParks {
  allBaseballParks {
    parks: nodes {
      parkId
      parkName
      doubleOrTripleProbability
      homeRunProbability
      singleProbability
      strikeoutProbability
      walkProbability
    }
  }
}
